import { DcsTextboxComponent } from './dcs-textbox.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [DcsTextboxComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  exports: [DcsTextboxComponent],
})
export class DcsTextboxModule { }
